import useLoginContext from '@/context/LoginFlowContextProvider/useLoginContext';

export enum AccountFF {
  Journey = 420001,
  Gather_AI = 420154
}

const useAccountsFF = (accountIds: number[]) => {
  const { currentAccount } = useLoginContext();
  if (!currentAccount) return false;
  return accountIds.includes(currentAccount.id);
};

export default useAccountsFF;
